if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      constructor() {
        super();
        this.addButton = this.querySelector('[data-cart-drawer-upsell-add]');
        this.spinner = this.querySelector('.cart-drawer__upsell-spinner');
        this.addButton?.addEventListener('click', this.onAddClick.bind(this));
      }

      onAddClick(event) {
        event.preventDefault();
        const variantId = this.dataset.variantId;
        const cartDrawer = document.querySelector('cart-drawer');
        if (!variantId || !cartDrawer || this.addButton.disabled) return;

        this.setLoading(true);

        const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const errors = document.getElementById('CartDrawer-CartErrors');
              if (errors) errors.textContent = response.description || window.cartStrings?.error;
              return;
            }

            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-drawer-upsell',
                productVariantId: variantId,
                cartData: response,
              });
            }
          })
          .catch(() => {
            const errors = document.getElementById('CartDrawer-CartErrors');
            if (errors) errors.textContent = window.cartStrings?.error;
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        if (!this.addButton) return;
        this.addButton.disabled = isLoading;
        this.addButton.classList.toggle('loading', isLoading);
        if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
      }
    }
  );
}
